{
    "coordinates": [
        47.92731841568056,
        10.590585771501367
    ],
    "tooltip": "Hammerschmiede",
    "title": "Hammerschmiede Clay Pit",
    "country": "Germany",
    "period": "Neogene",
    "alt": "TODO"
}
